import Vue from 'vue';
import VueMeta from 'vue-meta';

import { cdn_url } from '@core/mixins/cdnUrl';

Vue.use(VueMeta, { refreshOnceOnNavigation: true });

export default {
    title: '',
    titleTemplate: '%s',
    link: [
        { rel: 'icon', href: cdn_url('core/favicon.ico') },
    ],
};
